import hash from "hash.js";

export default class Encrypt {
  static hash(password: string): string {
    return hash.sha256().update(password).digest("hex").toString();
  }
}
